/**
 * Map multi-step consultation wizard data → Firestore `leads` shape (message bundles details).
 */
export function buildLeadFromConsultation(consultationData) {
  const name =
    consultationData.fullName ||
    consultationData.name ||
    '';
  const email =
    consultationData.emailAddress ||
    consultationData.email ||
    '';
  const phone =
    consultationData.phoneNumber ||
    consultationData.phone ||
    '';

  const lines = [
    `City: ${consultationData.cityLocation || '—'}`,
    `Project type: ${consultationData.projectType || '—'}`,
    `Property: ${consultationData.propertyType || '—'}`,
    `Area: ${consultationData.areaSize || '—'}`,
    `Budget: ${consultationData.budgetRange || '—'}`,
    `Style: ${consultationData.stylePreference || '—'}`,
    `Colors: ${consultationData.colorPreference || '—'}`,
    `Preferred date: ${consultationData.preferredDate || '—'}`,
    `Preferred time: ${consultationData.preferredTime || '—'}`,
    `Site visit: ${consultationData.siteVisitRequired || '—'}`,
    `WhatsApp contact: ${consultationData.contactWhatsApp ? 'Yes' : 'No'}`,
    '',
    'Notes / requirements:',
    consultationData.messageRequirements || '—',
  ];

  const message = lines.join('\n');

  return {
    name,
    email,
    phone,
    message,
    extraFields: {
      source: 'book_consultation',
    },
  };
}
